const formatMoney = (amount: number, removeCurrency = false): string => {
  const formatted = amount.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  if (removeCurrency) {
    return formatted.replace('R$', '')
  }

  return formatted
}

export { formatMoney }
